var _path, _path2, _path3, _circle, _path4, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    fill: "none",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M105 52.5a52.5 52.5 0 1 0-105 0h16.392a36.107 36.107 0 1 1 72.216 0H105Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M86.565 52.5a34.065 34.065 0 0 0-68.13 0h.517a33.55 33.55 0 0 1 67.097 0h.516Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.71 6.45A52.5 52.5 0 0 0 0 52.5h16.392A36.109 36.109 0 0 1 69.84 20.828l7.87-14.379Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.963,
    cy: 51.254,
    r: 4.008,
    fill: "#fff",
    transform: "rotate(30 51.963 51.254)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M65.344 27.709a.185.185 0 0 1 .32.184L54.282 51.675a2.226 2.226 0 1 1-3.843-2.219l14.905-21.748Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.364,
    cy: 50.559,
    r: 0.802,
    fill: "#fff",
    transform: "rotate(30 52.364 50.56)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD4);
export default __webpack_public_path__ + "static/media/d4.34d6facca746127002abed4a25631277.svg";
export { ForwardRef as ReactComponent };